import React, { ReactNode } from "react";

export const Conditional = ({ condition, children }: { condition: boolean; children: ReactNode }) => {
  if (!condition) return null;
  return <>{children}</>;
};
